// src/components/JumpToAudioButton.jsx
//
// Reader action: smooth-scrolls to the pack-level "Analysis Podcasts" audio block.
// Rendered just below the Save/Notes action row in BOTH the grouped and set-text
// readers (premium charcoal/gold to echo the AudioList block it scrolls to). The
// caller gates on pack-level audio presence (renders nothing when there is none),
// so the button never scrolls to an empty target. Presentational only -- the reader
// owns the target ref and the scroll handler and passes onJump in.
import React from 'react';
import { IconHeadphones } from './icons.jsx';

export default function JumpToAudioButton({ onJump }) {
    return (
        <div className="flex items-center justify-end mb-3">
            <button
                onClick={onJump}
                title="Jump to the Analysis Podcasts"
                className="flex items-center gap-1.5 px-3 py-1.5 min-h-[44px] md:min-h-0 bg-book-charcoal border border-book-accent/50 text-book-accent hover:bg-book-accent/15 hover:border-book-accent font-display text-sm transition-colors font-medium rounded-full">
                <IconHeadphones className="w-3.5 h-3.5" />
                <span>Jump to audio</span>
            </button>
        </div>
    );
}
